import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { CameraPanelProps } from "./CameraPanel";
const CameraPanel = lazy(() => import("./CameraPanel").then((module) => ({ default: module.CameraPanel })));

/** The Camera tab on the storyboard step; a production without shots clears the slot. */
export function mountCameraPanel(projectId: string, props: CameraPanelProps | null) {
  if (!props) return clearStudioView("camera-panel");
  setStudioView("camera-panel", `camera-panel:${projectId}`, <CameraPanel {...props} />);
}
